"use strict";

// @file Enums
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortByTypes = exports.ReactionType = exports.GroupByTypes = void 0;
var GroupByTypes;
(function (GroupByTypes) {
  GroupByTypes["None"] = "none";
  GroupByTypes["Section"] = "section";
  GroupByTypes["Author"] = "author";
  GroupByTypes["Color"] = "color";
})(GroupByTypes || (GroupByTypes = {}));
exports.GroupByTypes = GroupByTypes;
var SortByTypes;
(function (SortByTypes) {
  SortByTypes["ManualNewPostsFirst"] = "manual_new_posts_first";
  SortByTypes["ManualNewPostsLast"] = "manual_new_posts_last";
  SortByTypes["ReactionsAsc"] = "reactions_asc";
  SortByTypes["ReactionsDesc"] = "reactions_desc";
  SortByTypes["DatePublishedSortAsc"] = "date_published_asc";
  SortByTypes["DatePublishedSortDesc"] = "date_published_desc";
  SortByTypes["PostSubjectAsc"] = "post_subject_asc";
  SortByTypes["PostSubjectDesc"] = "post_subject_desc";
  SortByTypes["Shuffle"] = "shuffle";
})(SortByTypes || (SortByTypes = {}));
exports.SortByTypes = SortByTypes;
var ReactionType;
(function (ReactionType) {
  ReactionType["None"] = "none";
  ReactionType["Like"] = "like";
  ReactionType["Vote"] = "vote";
  ReactionType["Star"] = "star";
  ReactionType["Grade"] = "grade";
})(ReactionType || (ReactionType = {}));
exports.ReactionType = ReactionType;